import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAnswers, saveSurvey } from "../api/survey.api";
import { SaveSurveyRequest } from "../types/survey.types";
import { setSurvey } from "./reducer";

export const fetchSurveyAnswers = createAsyncThunk(
  "survey/fetchAnswers",
  async (questionnaireId: number, { rejectWithValue }) => {
    try {
      const response = await getAnswers(questionnaireId);
      if (!response.success || !response.data) {
        return rejectWithValue("No answers data");
      }
      return {
        questionnaireId: response.data.questionnaire_id ?? 0,
        answers: response.data.answers ?? {},
        completion_per: Number(response.data.completion_per) ?? 0,
      };
    } catch (err) {
      return rejectWithValue(
        err instanceof Error ? err.message : "Failed to fetch answers",
      );
    }
  },
);

export const saveSurveyAnswers = createAsyncThunk(
  "survey/saveAnswers",
  async (payload: SaveSurveyRequest, { rejectWithValue, dispatch }) => {
    try {
      console.log("payload", payload);
      const response = await saveSurvey(payload);
      if (!response.success || !response.data) {
        return rejectWithValue("No answers data");
      }
      const { answers, completion_per } = response.data;
      dispatch(
        setSurvey({
          answers: answers ?? {},
          completion_per: Number(completion_per) ?? 0,
        }),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err instanceof Error ? err.message : "Failed to save answers",
      );
    }
  },
);
